import { useState } from 'react';
import { ROLE_LABELS, ROLE_COLORS, menuItemStyle } from './shared.js';

export default function UserRow({ user, isSelected, isCurrent, isAdmin, theme, isInactive, onClick, onRoleChange, onEdit, onDeactivate, onReactivate }) {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div
      onClick={onClick}
      style={{
        padding: '10px 20px',
        display: 'flex', alignItems: 'center', gap: 12,
        cursor: 'pointer',
        background: isSelected ? theme.accentBg : 'transparent',
        borderLeft: isSelected ? `3px solid ${theme.accent}` : '3px solid transparent',
        opacity: isInactive ? 0.5 : 1,
        transition: 'background 0.1s',
      }}
      onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = theme.bgHover; }}
      onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'transparent'; setShowMenu(false); }}
    >
      <div style={{
        width: 34, height: 34, borderRadius: '50%',
        background: user.color || '#4F8EF7',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0,
      }}>{user.initials || '??'}</div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 13, fontWeight: 600, color: theme.text,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {user.name}
          {isCurrent && <span style={{ fontSize: 10, color: theme.textFaint, marginLeft: 6 }}>(you)</span>}
        </div>
        <div style={{
          fontSize: 11, color: theme.textMuted,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>{user.email}</div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <span style={{
          fontSize: 9, fontWeight: 600,
          color: ROLE_COLORS[user.role] || theme.accent,
          background: `${ROLE_COLORS[user.role] || theme.accent}18`,
          padding: '2px 7px', borderRadius: 4,
          letterSpacing: '0.04em', textTransform: 'uppercase',
        }}>{ROLE_LABELS[user.role] || user.role}</span>

        {user.fonts_uploaded > 0 && (
          <span style={{ fontSize: 10, color: theme.textGhost }}>
            {user.fonts_uploaded} fonts
          </span>
        )}

        {isAdmin && !isCurrent && !isInactive && (
          <div style={{ position: 'relative' }}>
            <button
              onClick={e => { e.stopPropagation(); setShowMenu(!showMenu); }}
              style={{
                background: 'none', border: 'none', color: theme.textFaint,
                cursor: 'pointer', fontSize: 16, padding: '2px 4px', lineHeight: 1,
              }}
            >...</button>
            {showMenu && (
              <div style={{
                position: 'absolute', right: 0, top: '100%', zIndex: 50,
                background: theme.bgElevated, border: `1px solid ${theme.borderHover}`,
                borderRadius: 8, padding: 4, minWidth: 150,
                boxShadow: theme.shadow,
              }}>
                <button
                  onClick={e => { e.stopPropagation(); onEdit?.(user); setShowMenu(false); }}
                  style={menuItemStyle(theme)}
                  onMouseEnter={e => e.currentTarget.style.background = theme.bgHover}
                  onMouseLeave={e => e.currentTarget.style.background = 'none'}
                >Edit Profile</button>
                {['admin', 'editor', 'viewer'].filter(r => r !== user.role).map(role => (
                  <button
                    key={role}
                    onClick={e => { e.stopPropagation(); onRoleChange?.(user.id, role); setShowMenu(false); }}
                    style={menuItemStyle(theme)}
                    onMouseEnter={e => e.currentTarget.style.background = theme.bgHover}
                    onMouseLeave={e => e.currentTarget.style.background = 'none'}
                  >Make {ROLE_LABELS[role]}</button>
                ))}
                <button
                  onClick={e => { e.stopPropagation(); onDeactivate?.(); setShowMenu(false); }}
                  style={{ ...menuItemStyle(theme), color: theme.red }}
                  onMouseEnter={e => e.currentTarget.style.background = theme.redBg}
                  onMouseLeave={e => e.currentTarget.style.background = 'none'}
                >Deactivate</button>
              </div>
            )}
          </div>
        )}

        {isInactive && isAdmin && (
          <button
            onClick={e => { e.stopPropagation(); onReactivate?.(); }}
            style={{
              padding: '4px 10px', fontSize: 10, fontWeight: 600,
              background: theme.greenBg, border: `1px solid ${theme.greenBorder}`,
              borderRadius: 5, color: theme.green,
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >Reactivate</button>
        )}
      </div>
    </div>
  );
}
